import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import MasterDetailsReport from "../../../common/components/MasterDetailsReport";
import noop from "../../../../../core/modules/common/tools/noop";

const CarditNestingReport = props => (
  <Report
    /* eslint-disable react/destructuring-assignment */
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.CARDIT_NESTING_CARRIER.id,
        label: 'Carrier',
      },
      {
        value: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
        label: 'Location',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.type.c.reports',
      },
      {
        value: ReportDefinitions.CARDIT_NESTING_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.type.c.reports',
      },
    ]}
    /* eslint-disable react/jsx-props-no-spreading */
    {...props}
  />
);
export default CarditNestingReport;

CarditNestingReport.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  masterDetailsReport: PropTypes.instanceOf(MasterDetailsReport),
  modeTabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string, label: PropTypes.string,
  })),
  mode: PropTypes.string,
  changeMode: PropTypes.func,
  id: PropTypes.string,
  onSortedChange: noop,
  onFilteredChange: noop,
};
